import { useTranslation } from "react-i18next";
import { useBoardProvider } from "../../contexts/board/boardContext";
import { useClients } from "../../data/queries/clientQueries";
import { useTaskTypeByBoardId } from "../../data/queries/taskTypeQueries";
import { DueDateYearFromTo } from "./DueDateYearFromTo";
import { RolloverClientsMultiselect } from "./RolloverClientsMultiselect";
import { RolloverTaskTypeDropdown } from "./RolloverTaskTypeDropdown";
import { CheckBox } from "@etframework/ui.components";

export const RolloverTasksContent = ({
  clientRef,
  selectAllClientsCheckboxRef,
  taskTypeRef,
  dueDateYearContentRef,
  onRolloverTasksCheckboxChange,
  onClientsChange,
  onTaskTypeChange,
  onDueDateYearContentChange,
}) => {
  const { t } = useTranslation(["RolloverTasksModal"]);
  const { currentBoardId } = useBoardProvider();
  const { data: clientData, isPending: clientsPending } = useClients();
  const { data: taskTypeData, isPending: taskTypesPending } =
    useTaskTypeByBoardId(currentBoardId);

  if (clientsPending || taskTypesPending) return null;

  return (
    <div className="rollover-tasks-content mt-4">
      <div className="mt-4">
        <RolloverClientsMultiselect
          ref={clientRef}
          id="rollover-tasks-client"
          name="Clients"
          label={t("SelectClients")}
          dataSource={clientData ?? []}
          fields={{
            text: "FullName",
            value: "Id",
          }}
          change={onClientsChange}
        />
        <div className="mt-1">
          <CheckBox
            ref={selectAllClientsCheckboxRef}
            id="rollover-tasks-checkbox"
            label={t("SelectAllClients")}
            change={onRolloverTasksCheckboxChange}
          />
        </div>
      </div>
      <div className="mt-4">
        <RolloverTaskTypeDropdown
          ref={taskTypeRef}
          id="rollover-tasks-task-type"
          name="TaskType"
          label={t("SelectTaskTypeForRollover")}
          dataSource={taskTypeData ?? []}
          fields={{
            text: "Title",
            value: "Id",
          }}
          change={onTaskTypeChange}
        />
      </div>

      <div className="mt-4">
        <DueDateYearFromTo
          ref={dueDateYearContentRef}
          change={onDueDateYearContentChange}
        />
      </div>
    </div>
  );
};
